import React from 'react';
import { Building2, Home, Building } from 'lucide-react';
import { StepButtons } from '../ui';

interface PropertyTypeStepProps {
  value: {
    propertyType: 'apartment' | 'house' | 'building' | null;
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack?: () => void;
}

export const PropertyTypeStep: React.FC<PropertyTypeStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const handleTypeSelect = (type: 'apartment' | 'house' | 'building') => {
    onChange('propertyType', type);
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-primary">Type de bien</h2>
      
      <div className="grid grid-cols-3 gap-4">
        <PropertyCard
          icon={<Building2 className="h-8 w-8" />}
          type="apartment"
          label="Appartement"
          selected={value.propertyType === 'apartment'}
          onClick={() => handleTypeSelect('apartment')}
        />
        <PropertyCard
          icon={<Home className="h-8 w-8" />}
          type="house"
          label="Maison"
          selected={value.propertyType === 'house'}
          onClick={() => handleTypeSelect('house')}
        />
        <PropertyCard
          icon={<Building className="h-8 w-8" />}
          type="building"
          label="Immeuble"
          selected={value.propertyType === 'building'}
          onClick={() => handleTypeSelect('building')}
        />
      </div>

      <StepButtons
        onNext={onNext}
        onBack={onBack}
        disabled={!value.propertyType}
      />
    </div>
  );
};

interface PropertyCardProps {
  icon: React.ReactNode;
  type: string;
  label: string;
  selected: boolean;
  onClick: () => void;
}

const PropertyCard: React.FC<PropertyCardProps> = ({
  icon,
  label,
  selected,
  onClick
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`
      card flex flex-col items-center p-6 transition-all
      ${selected ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
    `}
  >
    <div className={`mb-4 ${selected ? 'text-primary' : 'text-neutral-600'}`}>
      {icon}
    </div>
    <span className={`font-medium ${selected ? 'text-primary' : 'text-neutral-700'}`}>
      {label}
    </span>
  </button>
);

export default PropertyTypeStep;